var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1662 23.4303L19.4749 58.946L17.7378 58.7295L22.0805 22.9972L23.1662 23.4303Z",
    fill: "#1EE2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6008 21.9143L2.82854 15.3709L4.77758 22.6802L0 28.2662L21.7875 35.6931L23.6008 21.9143Z",
    fill: "#1EE2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28.2659L4.77758 22.6799L2.82854 15.3707L23.6008 21.9141L4.68895 17.4629L5.66347 23.503L0 28.2659Z",
    fill: "#9CFFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2891 35.7381L33.947 43.8185L36.1939 43.1462L35.0704 34.6308L30.2891 35.7381Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7547 35.5271L56.971 43.8184L54.7241 43.1461L56.029 33.1408L60.7547 35.5271Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6144 82.6877C28.6144 82.6877 20.5089 82.9327 23.702 86.3623C26.895 89.7918 39.4219 84.6475 39.4219 84.6475L28.6144 82.6877Z",
    fill: "url(#paint0_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.45 82.6877C65.45 82.6877 73.5556 82.9327 70.3624 86.3623C67.1693 89.7918 54.6426 84.6475 54.6426 84.6475L65.45 82.6877Z",
    fill: "url(#paint1_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6541 55.8465L27.016 54.946C25.6062 54.1546 24.0837 53.5821 22.5009 53.2482C21.2527 52.9853 19.9009 52.8844 18.7461 53.4251C17.0882 54.2012 16.2508 56.1288 16.1478 57.9524C16.1023 58.7587 16.1767 59.5902 16.5223 60.3205C17.2619 61.8832 19.0261 62.6366 20.6428 63.2581L24.7155 64.8239C24.8714 64.8838 25.0431 64.9444 25.2016 64.8917C25.2993 64.8524 25.3856 64.7892 25.4524 64.708C25.9506 64.1711 26.1541 63.4332 26.3413 62.726L27.2131 59.4332L27.0789 57.0637C27.0784 57.1194 27.6541 55.7905 27.6541 55.8465Z",
    fill: "url(#paint2_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6938 56.0808L66.3319 55.1803C67.7418 54.3889 69.2644 53.8164 70.8472 53.4825C72.0953 53.2195 73.4472 53.1187 74.602 53.6594C76.2597 54.4355 77.0972 56.3631 77.2002 58.1867C77.2458 58.993 77.1713 59.8245 76.8257 60.5548C76.0861 62.1174 74.3219 62.8709 72.7053 63.4924L68.6326 65.0582C68.4766 65.1181 68.305 65.1787 68.1464 65.126C68.0488 65.0866 67.9626 65.0235 67.8957 64.9423C67.3975 64.4054 67.1939 63.6675 67.0067 62.9603C66.7163 61.8626 66.4257 60.765 66.135 59.6675L66.2691 57.298C66.2696 57.3537 65.6938 56.0252 65.6938 56.0808Z",
    fill: "url(#paint3_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5216 52.654C73.551 51.88 72.5818 51.3574 72.0195 50.1827C71.4757 49.0468 71.642 47.6522 71.8633 46.4611C72.271 44.2635 73.2515 42.3098 72.9481 40.0195C72.9449 39.9991 72.9339 39.9808 72.9174 39.9684C72.9008 39.9561 72.8801 39.9507 72.8596 39.9535C72.8391 39.9562 72.8205 39.9669 72.8078 39.9831C72.7951 39.9994 72.7894 40.02 72.7917 40.0404C73.1184 43.4727 69.3824 48.6503 72.6008 51.6005C73.3877 52.3218 74.3383 52.83 75.0691 53.6151C76.1603 54.7874 75.808 56.5833 75.3673 57.9416C74.7457 59.857 73.4084 61.6758 73.9756 63.766C73.9798 63.7891 73.9927 63.8096 74.0117 63.8234C74.0306 63.8372 74.0542 63.8431 74.0774 63.84C74.1007 63.8369 74.1218 63.825 74.1365 63.8067C74.1511 63.7884 74.1582 63.7652 74.1561 63.7419C74.1248 60.0767 78.284 55.6542 74.5216 52.654Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4012 38.8293L68.9409 41.4325L75.963 41.191L73.9891 38.1165L70.4012 38.8293Z",
    fill: "url(#paint4_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.83 39.2383C81.7605 38.4348 88.235 29.3253 87.2912 18.8917C86.3474 8.45817 78.3428 0.651482 69.4123 1.455C60.4818 2.25853 54.0073 11.368 54.9511 21.8015C55.8948 32.2351 63.8995 40.0418 72.83 39.2383Z",
    fill: "url(#paint5_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.8299 39.2382C81.7604 38.4346 88.2344 29.3252 87.2908 18.8916C86.4413 9.50016 79.8702 2.24074 72.0532 1.46951C73.7107 2.56915 75.1108 4.01246 76.158 5.70095C78.114 8.84062 78.8964 12.5872 79.0561 16.2801C79.1208 17.7737 79.0883 19.2801 78.8001 20.7471C78.0334 24.6486 75.4028 28.1028 71.9336 30.062C68.4645 32.0211 64.2297 32.5063 60.353 31.5801C59.6235 31.4059 58.8309 31.1937 58.1084 31.2735C61.4313 36.5374 66.9274 39.7693 72.8299 39.2382Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2379 36.0622C77.2401 35.6121 81.115 33.254 80.8925 30.7951C80.6701 28.3363 76.4347 26.7078 71.4324 27.1579C66.4301 27.608 62.5553 29.9662 62.7777 32.425C63.0001 34.8839 67.2356 36.5123 72.2379 36.0622Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4121 1.45495C60.4817 2.25845 54.0075 11.3679 54.9512 21.8015C55.554 28.4651 59.0391 34.0525 63.8039 37.0144C63.5853 36.6901 63.3794 36.3605 63.1886 36.0284C60.1874 30.808 59.2767 24.5503 59.962 18.5716C60.225 16.2769 60.7243 13.9765 61.799 11.9307C62.5769 10.4497 63.6393 9.13477 64.7813 7.91088C67.1829 5.33735 70.0128 3.10407 73.2009 1.63216C71.9519 1.40212 70.6773 1.3425 69.4121 1.45495Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2342 10.8139C65.3007 9.49169 64.2799 8.36609 62.9542 8.29978C61.6285 8.23347 60.4999 9.25156 60.4334 10.5738C60.3669 11.8959 61.3877 13.0215 62.7134 13.0878C64.0391 13.1542 65.1677 12.1361 65.2342 10.8139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4314 28.4879C79.9376 28.3059 80.2001 27.7491 80.0176 27.2442C79.8351 26.7393 79.2768 26.4776 78.7706 26.6596C78.2644 26.8416 78.0019 27.3984 78.1844 27.9033C78.3669 28.4081 78.9252 28.6699 79.4314 28.4879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0895 61.4032C71.1398 66.9875 74.5578 75.8804 69.7219 81.1633C64.608 86.7502 53.4408 86.0753 46.7588 86.0753C40.0769 86.0753 28.9096 86.75 23.7957 81.1633C18.9598 75.8804 22.3779 66.9876 24.4282 61.4031C27.6292 52.6845 34.5594 32.5771 46.7588 32.5768C58.9582 32.5765 65.8885 52.6848 69.0895 61.4032Z",
    fill: "url(#paint6_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5623 47.8971C59.6918 40.0736 54.2076 32.5768 46.7587 32.5769C34.5593 32.5769 27.6291 52.6845 24.4281 61.4032C22.6497 66.2469 19.8462 73.5781 22.2882 78.8854C22.0233 76.9861 22.0647 75.0568 22.4109 73.1706C23.6114 66.7354 32.4647 34.5592 45.3695 33.8109C52.2924 33.4095 58.912 40.8466 63.5623 47.8971Z",
    fill: "#FFE436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1585 37.4044C35.3858 37.4044 38.8126 34.073 38.8126 29.9636C38.8126 25.8541 35.3858 22.5227 31.1585 22.5227C26.9313 22.5227 23.5044 25.8541 23.5044 29.9636C23.5044 34.073 26.9313 37.4044 31.1585 37.4044Z",
    fill: "#FFE436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1585 36.6452C35.3858 36.6452 38.8126 33.4838 38.8126 29.584C38.8126 25.6841 35.3858 22.5227 31.1585 22.5227C26.9313 22.5227 23.5044 25.6841 23.5044 29.584C23.5044 33.4838 26.9313 36.6452 31.1585 36.6452Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7758 34.9912C34.7917 34.9912 38.0473 32.2001 38.0473 28.757C38.0473 25.3139 34.7917 22.5227 30.7758 22.5227C26.7599 22.5227 23.5044 25.3139 23.5044 28.757C23.5044 32.2001 26.7599 34.9912 30.7758 34.9912Z",
    fill: "url(#paint7_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.7759 34.9913C34.7917 34.9913 38.0473 32.2001 38.0473 28.757C38.0465 27.9971 37.8865 27.2458 37.5774 26.5513C37.3348 27.0277 37.0245 27.4669 36.6562 27.855C35.5742 28.9921 34.1007 29.6852 32.5991 30.1486C30.6578 30.7479 28.5649 31.0014 26.5864 30.5384C25.4616 30.2788 24.4106 29.7678 23.5127 29.0439C23.6878 32.3537 26.8721 34.9913 30.7759 34.9913Z",
    fill: "#DBA75C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9793 32.485C32.4589 32.485 33.6583 31.3458 33.6583 29.9405C33.6583 28.5351 32.4589 27.3959 30.9793 27.3959C29.4997 27.3959 28.3003 28.5351 28.3003 29.9405C28.3003 31.3458 29.4997 32.485 30.9793 32.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7241 31.849C32.0628 31.849 33.148 30.8521 33.148 29.6224C33.148 28.3927 32.0628 27.3959 30.7241 27.3959C29.3855 27.3959 28.3003 28.3927 28.3003 29.6224C28.3003 30.8521 29.3855 31.849 30.7241 31.849Z",
    fill: "#574120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1702 28.6244C30.5688 28.227 30.5688 27.5825 30.1702 27.185C29.7717 26.7875 29.1255 26.7875 28.727 27.185C28.3285 27.5825 28.3285 28.227 28.727 28.6244C29.1255 29.0219 29.7717 29.0219 30.1702 28.6244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.412 26.5094C35.5926 25.3997 34.8369 24.3541 33.7242 24.174C32.6115 23.9939 31.5631 24.7476 31.3826 25.8573C31.202 26.967 31.9577 28.0126 33.0704 28.1927C34.1831 28.3728 35.2315 27.6192 35.412 26.5094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7166 36.9562C65.9439 36.9562 69.3707 33.6249 69.3707 29.5154C69.3707 25.4059 65.9439 22.0745 61.7166 22.0745C57.4894 22.0745 54.0625 25.4059 54.0625 29.5154C54.0625 33.6249 57.4894 36.9562 61.7166 36.9562Z",
    fill: "#FFE436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7166 36.197C65.9439 36.197 69.3707 33.0356 69.3707 29.1358C69.3707 25.236 65.9439 22.0745 61.7166 22.0745C57.4894 22.0745 54.0625 25.236 54.0625 29.1358C54.0625 33.0356 57.4894 36.197 61.7166 36.197Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3339 34.5431C65.3498 34.5431 68.6054 31.7519 68.6054 28.3088C68.6054 24.8657 65.3498 22.0745 61.3339 22.0745C57.318 22.0745 54.0625 24.8657 54.0625 28.3088C54.0625 31.7519 57.318 34.5431 61.3339 34.5431Z",
    fill: "url(#paint8_radial_247_906)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.3339 34.5431C65.3499 34.5431 68.6053 31.7519 68.6053 28.3088C68.6046 27.549 68.4445 26.7976 68.1355 26.1031C67.8929 26.5796 67.5826 27.0187 67.2143 27.4068C66.1323 28.544 64.6587 29.237 63.1572 29.7004C61.2159 30.2997 59.123 30.5532 57.1445 30.0903C56.0197 29.8306 54.9687 29.3196 54.0708 28.5957C54.2459 31.9055 57.4302 34.5431 61.3339 34.5431Z",
    fill: "#DBA75C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5374 32.0368C63.017 32.0368 64.2164 30.8975 64.2164 29.4922C64.2164 28.0868 63.017 26.9476 61.5374 26.9476C60.0578 26.9476 58.8584 28.0868 58.8584 29.4922C58.8584 30.8975 60.0578 32.0368 61.5374 32.0368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2822 31.4007C62.6209 31.4007 63.7061 30.4038 63.7061 29.1741C63.7061 27.9445 62.6209 26.9476 61.2822 26.9476C59.9436 26.9476 58.8584 27.9445 58.8584 29.1741C58.8584 30.4038 59.9436 31.4007 61.2822 31.4007Z",
    fill: "#574120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0069 28.4744C60.5705 28.4744 61.0274 28.0187 61.0274 27.4566C61.0274 26.8945 60.5705 26.4388 60.0069 26.4388C59.4432 26.4388 58.9863 26.8945 58.9863 27.4566C58.9863 28.0187 59.4432 28.4744 60.0069 28.4744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9419 26.2028C66.2009 25.1087 65.5215 24.0123 64.4244 23.754C63.3273 23.4956 62.228 24.1732 61.969 25.2674C61.71 26.3616 62.3894 27.458 63.4865 27.7163C64.5836 27.9746 65.6829 27.297 65.9419 26.2028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6084 62.6853C34.6084 62.6853 45.4453 70.5458 58.581 62.6853C58.581 62.6853 43.4749 66.6155 34.6084 62.6853Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3506 64.2192C37.3506 64.2192 37.1547 59.2382 38.036 58.8476C38.9174 58.4569 42.9324 59.6289 42.9324 59.6289L41.3623 65.5263L37.3506 64.2192Z",
    fill: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7543 64.1309C55.7543 64.1309 55.952 59.1054 55.0706 58.7147C54.1892 58.324 50.1743 59.4961 50.1743 59.4961L51.8391 65.5513L55.7543 64.1309Z",
    fill: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.6086 83.702C31.2107 83.8057 31.8157 83.8967 32.4241 83.967C38.093 84.6226 44.1005 83.7613 49.6795 82.7021C54.8645 81.7177 60.1125 80.3286 64.8935 78.0579C67.45 76.8437 70.1097 75.3371 72.1685 73.3638C71.9937 69.1744 70.3031 64.7096 69.0893 61.4034C68.9223 60.9487 68.7438 60.4596 68.5564 59.9473C64.2096 66.9945 56.2495 71.984 48.6618 74.8251C43.0745 76.9171 37.0783 78.1352 31.0938 77.8562C28.2312 77.7085 25.3966 77.2193 22.6507 76.3991C22.2703 76.2873 21.8724 76.166 21.4663 76.0331C21.6582 77.3608 22.0652 78.6236 22.7581 79.77C22.7581 79.77 25.7538 82.1378 30.6086 83.702Z",
    fill: "#FF3300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-157.719 86.852) scale(17.0381 16.9677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-324.3 86.852) rotate(180) scale(17.0381 16.9677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7686 52.5595) scale(12.9462 12.9106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-555.63 52.7938) rotate(180) scale(12.9462 12.9106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-88.9454 44.2313) scale(5.65841 5.63733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.9933 21.6644) rotate(-0.743049) scale(17.6731 17.6604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7598 50.882) scale(36.6461 36.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1569 23.2833) scale(15.5961 15.5482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_247_906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.703 22.8351) scale(15.5961 15.5482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppFeatureIcon);
export default __webpack_public_path__ + "static/media/appFeatureIcon.b234eba781868b355e48024d74ec5299.svg";
export { ForwardRef as ReactComponent };